import actions, { imageActions } from './constants';

export const showThemes = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_THEMES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showThemesError = (category, error) => ({
  type: actions.SHOW_THEMES_ERROR,
  category,
  error,
});

export const closeThemes = (category) => ({
  type: actions.CLOSE_THEMES,
  category,
});

export const chooseThemeError = (code, name, error) => ({
  type: actions.CHOOSE_THEME_ERROR,
  code,
  name,
  error,
});

export const editTheme = (code, result) => ({
  type: actions.EDIT_THEME,
  code,
  result,
});

export const editThemeEnabled = (code, category, result) => ({
  type: actions.EDIT_THEME_ENABLED,
  code,
  category,
  result,
});

export const editThemeError = (error) => ({
  type: actions.EDIT_THEME_ERROR,
  error,
});

export const editThemeEnabledError = (code, category, name, error) => ({
  type: actions.EDIT_THEME_ENABLED_ERROR,
  code,
  category,
  name,
  error,
});

export const applyTheme = (theme) => ({
  type: actions.APPLY_THEME,
  theme,
});

export const showImageSuccess = (items) => ({
  type: imageActions.SHOW_IMAGE_SUCCESS,
  items,
});

export const showImageError = (items) => ({
  type: imageActions.SHOW_IMAGE_ERROR,
  items,
});
